import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '@app/_core/helper/Utils';

import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
@Injectable({
  providedIn: 'root',
})
export class ConsoleService {
  hasAuditSurvey: boolean = false;
  constructor(
    private router: Router,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService
  ) {}

  setUserDetails() {
    const pl: any = {};
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.capResults = true;
    pl.company = company;
    return pl;
  }
  hasAuditSurveyExperience(): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/HasAuditSurveyExperience`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        //res = {"Response":{"Data":true,"Status":1,"Message":null},"Status":1,"Message":null}
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  /*
  getAction(): any {
    let user = this.webStorageService.getItemFromSessionStorage('currentUser');
    let company = this.webStorageService.getItemFromSessionStorage('company')
    const uc = { 'user': user, 'company': company };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetQueues`, uc).pipe(
      map((res) => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }*/
}
